import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import { RequestsService } from 'src/app/core/services/http/requests.service';
import { Urls } from 'src/app/lib/urls';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from 'ngx-toastr';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ApiService } from 'src/app/services/api.service';
import { firstValueFrom } from 'rxjs';
import { SharedComponentsModule } from 'src/app/shared/modules/shared-component.module';
import { SharedDirectivesModule } from "src/app/shared/modules/shared-directives.module";
import { MatTooltipModule } from '@angular/material/tooltip';
@Component({
  selector: 'app-accounts-edit',
  templateUrl: './accounts-edit.component.html',
  styleUrls: ['./accounts-edit.component.scss'],
  imports: [ReactiveFormsModule, CommonModule, SharedComponentsModule, SharedDirectivesModule, MatTooltipModule],
  standalone: true
})
export class AccountsEditComponent implements OnInit {

  public accountsEditForm!: UntypedFormGroup;
  tierTypeOptions = [
    { label: 'Default', value: 1 },
    { label: 'Full', value: 4 },
    { label: 'Internal', value: 5 },
    { label: 'MegaBiz', value: 7 },
    { label: 'MegaOne', value: 8 },
    { label: 'BLA', value: 9 },
  ];

  accountTypeOptions = [
    { label: 'Not Merchant', value: 1 },
    { label: 'Merchant', value: 2 },
  ];

  uid: any;
  userName: any;
  currentEmail: any;
  currentTier_text: any;
  currentAccountType_text: any;



  // tiertype
  tierType_text: any;
  tierId: any;

  // account type
  accountType_text: any;
  memberLevel: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb : UntypedFormBuilder,
    private request: RequestsService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private apiService: ApiService
  ) {
    this.initializeForm()
  }

  ngOnInit(): void {
    this.uid = this.route.snapshot.paramMap.get('id');
    this.get_user();
  }

  initializeForm(){
    this.accountsEditForm = this.fb.group({
      firstName: [''],
      middleName: [''],
      lastName: [''],
      userName: [''],
      email: [''],
    });
  }

  async get_user() {
      const response = await firstValueFrom(
        this.apiService.getAccountById(this.uid)
      );
      this.userName = response.result.userName;
      this.currentEmail = response.result.email;
      this.tierId = response.result.tierId;
        if (response.result.tierId === 1){
          this.currentTier_text = 'Default';
        }else if (response.result.tierId === 4) {
          this.currentTier_text = ' Full';
        }else if (response.result.tierId === 5) {
          this.currentTier_text = 'Internal';
        }else if (response.result.tierId === 6) {
          this.currentTier_text = 'Business';
        }else if (response.result.tierId === 7) {
          this.currentTier_text = 'MegaBiz';
        }else if (response.result.tierId === 8){
          this.currentTier_text = 'MegaOne';
        }else if (response.result.tierId === 9){
          this.currentTier_text = 'BLA';
        }else {
          this.currentTier_text = 'N / A';
        }
      this.memberLevel = response.result.memberLevel;
        if (response.result.memberLevel === 1){
          this.currentAccountType_text = 'Not Merchant';
        }else {
          this.currentAccountType_text = 'Merchant';
        }
      this.accountsEditForm = this.fb.group({
        firstName: (response.result.firstName),
        middleName: (response.result.middleName),
        lastName: (response.result.lastName),
        userName: (response.result['']),
        email: (response.result['']),
      });
  }

  update(): void {
    this.spinner.show().catch((err) => console.log('Spinner Show Error:', err));

    const requestBody = {
      firstName: this.accountsEditForm.controls.firstName.value,
      middleName: this.accountsEditForm.controls.middleName.value,
      lastName: this.accountsEditForm.controls.lastName.value,
      userName: this.accountsEditForm.controls.userName.value,
      email: this.accountsEditForm.controls.email.value,
      tierId: this.tierId,
      memberLevel: this.memberLevel
    };

    this.apiService.updateAccountDetails(this.uid, requestBody).subscribe({
      next: (response) => {
        if (response.status === 200) {
          this.toastr.success(response.message + '!', 'Success!');
          this.router.navigate(['/accounts']).catch((err) => 
            this.toastr.error(
              `Please refresh or contact the developer if the error still occurs`,
              'Something went wrong'
            ));
        } else {
          this.toastr.error(response.error?.message + '!', 'Something went wrong!');
        }
      },
      error: (error) => {
        this.toastr.error('Update failed!', 'Something went wrong!');
      },
      complete: () => {
        this.spinner.hide().catch((err) => console.log('Spinner Hide Error:', err));
        this.accountsEditForm.reset();
        this.tierType_text = null;
        this.accountType_text = null;
      }
    });
  }

  setTierType(text: string, value: number): void {
    this.tierId = value;
    this.tierType_text = text;
  }

  setAccountType(text: string, value: number): void {
    this.memberLevel = value;
    this.accountType_text = text;
  }
}

